// 关于 主页顶部栏
export default {
  '语言':	'Language',
  '关于':	'About',
  '用户中心':'User Center',
  '运行环境':'Operating Environment',
  '最近更新日期':'Last Update Date',
  '广州里工实业有限公司':'Li-Gong Industrial Co., Ltd.',
  '电话':'Phone',
  '电子邮件':'E-mail',
  '网址':'Website',
}